<div class="container">
  <div class="col-md-12">
    <legend>Tractors</legend>
    <div class="btnRig">
      <button
        id="edit"
        name="edit"
        class="btn btn-primary"
        [routerLink]="newTractorRoute"
        *ngIf="hasPermission('TractorsChange')"
      >
        Add New Tractor
      </button>
    </div>
    <p-table
      #dt
      [columns]="tractorsCols"
      [value]="allRecord"
      sortMode="multiple"
      [scrollable]="true"
      scrollHeight="700px"
      [virtualScroll]="true"
      [virtualScrollItemSize]="46"
      stateStorage="session"
      stateKey="tractorslist-table"
    >
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col *ngFor="let col of columns" [style.width.px]="col.width || 150" />
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" style="width: 20%">
            {{ col.header }}
            <p-sortIcon *ngIf="col.header.length" [field]="col.field"></p-sortIcon>
          </th>
        </tr>
        <tr>
          <th *ngFor="let col of columns" [ngSwitch]="col.field">
            <input
              *ngIf="col.type !== 'boolean'"
              type="text"
              style="width: 100%"
              (input)="$any(dt).filter($event.target.value, col.field, 'contains')"
              [value]="$any(dt).filters[col.field]?.value"
            />
            <select
              *ngIf="col.type === 'boolean'"
              class="form-control"
              style="width: 100%"
              (change)="$any(dt).filter($any($event.target).value, col.field, 'equals')"
              [ngModel]="$any(dt).filters[col.field]?.value"
            >
              <option value="">All</option>
              <option *ngFor="let option of statusOptions" [value]="option.value">
                {{ option.label }}
              </option>
            </select>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-tractor>
        <tr class="clickable-row" (dblclick)="viewDetail(tractor)" style="height: 42px">
          <td>{{ tractor.unitNumber }}</td>
          <td>{{ tractor.driverName }}</td>
          <td>{{ tractor.year }}</td>
          <td>{{ tractor.make }}</td>
          <td>{{ tractor.licenseNumber }}</td>
          <td>{{ getCurrentLocation(tractor) }}</td>
          <td
            [style.color]="isPeopleNetStale(tractor) ? '#dc3545' : ''"
            [title]="getPeopleNetUpdatedTooltip(tractor)"
          >
            {{ getPeopleNetUpdated(tractor) }}
          </td>
          <td>{{ tractor.active }}</td>
          <td>{{ tractor.vinNo }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
